import React from 'react'
import Image from 'components/Common/Image'

export function NeverEndingSummerLogo() {
  return (
    <div>
      <Image image={{ id: 'never-ending-summer-logo' }} dpr={1} width={80} height={80} />
    </div>
  )
}
